import React, { useEffect, useRef, useState } from 'react';
import { FaCheck, FaPlus, FaSave } from 'react-icons/fa';
import { HiOutlineRefresh } from 'react-icons/hi';
import { IoPrint } from 'react-icons/io5';
import { LuView } from 'react-icons/lu';
import { MdEdit } from 'react-icons/md';
import { RiCloseLargeFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import A1 from '../../Images/logo-w.png';
import axios from 'axios';
import Select from 'react-select'

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { pdf } from '@react-pdf/renderer';
// import ReactPDF, { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink,Image  } from '@react-pdf/renderer';

import { Container, Row, Col, Form, Button, ListGroup, Card, Table } from 'react-bootstrap';
import './POvsMR.css'


const PIvs = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const id = user ? user.id : null;
    console.log(id)



    const [currentDate, setCurrentDate] = useState('');


    useEffect(() => {
        const date = new Date();
        const formattedDate = date.toISOString().split('T')[0];
        setCurrentDate(formattedDate);
    }, []);


    // const handlePrint = () => {
    //     console.log('Print functionality');
    // };

    const toggleModal = () => setIsModalOpen(!isModalOpen);






    const handleSave = (id) => {

    };

    const handleSubmit = (id) => {

    };

    const handleApprove = (id) => {

    };

    const handleRefresh = () => {

    };

    const [showEditformm, setShowEditFormm] = useState(false);
    const [showCreateForm, setShowCreateForm] = useState(false);
    const [showViewForm, setShowViewForm] = useState(false);





    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    const [formMode, setFormMode] = useState('');
    // const userPermissions = user ? {
    //     add: user.add_permission,
    //     edit: user.edit_permission,
    //     view: user.view_permission,
    //     save: user.save_permission,
    //     approve: user.approve_permission,
    //     print: user.print_permission,
    //     close: user.close_permission,
    //     clear: user.clear_screen_permission
    // } : {};
    const userPermissions = user && user.permissions && user.permissions[1000]
        ? {
            add: user.permissions[3000].sub_ids[3001]?.permissions.add_permission || 0,
            edit: user.permissions[3000].sub_ids[3001]?.permissions.edit_permission || 0,
            view: user.permissions[3000].sub_ids[3001]?.permissions.view_permission || 0,
            save: user.permissions[3000].sub_ids[3001]?.permissions.save_permission || 0,
            approve: user.permissions[3000].sub_ids[3001]?.permissions.approve_permission || 0,
            print: user.permissions[3000].sub_ids[3001]?.permissions.print_permission || 0,
            close: user.permissions[3000].sub_ids[3001]?.permissions.exit_permission || 0,
            clear: user.permissions[3000].sub_ids[3001]?.permissions.refresh_permission || 0
        }
        : {};

    const getButtonState = (permissionType) => {
        switch (formMode) {
            case 'create':
                return permissionType === 'create' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'edit':
                return permissionType === 'edit' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'view':
                return permissionType === 'view' || permissionType === 'clear' || permissionType === 'close';
            case 'approve':
                return permissionType === 'clear' || permissionType === 'view' || permissionType === 'approve' || permissionType === 'print' || permissionType === 'close';
            default:
                return false;
        }
    };










    // const [indents, setIndents] = useState([]);
    // const [items, setItems] = useState('');

    // const [combinedData, setCombinedData] = useState([]);


    // useEffect(() => {

    //     axios.get('https://erpapi.emedha.in/pages/api/api/items-indents')
    //         .then((response) => {
    //             //  setItems(response.data)

    //             // const filteredItems = response.data.filter(item => item.Flage === 1);
    //             const filteredItems = response.data.filter(item => item.Flage === 1 && item.PO_rais !== 1);

    //             setItems(filteredItems);
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching state master:', error);
    //         });
    // }, []);

    // useEffect(() => {
    //     const fetchPendingIndents = async () => {
    //         try {
    //             const response = await fetch('https://erpapi.emedha.in/pages/api/api/pending-indents');

    //             const data = await response.json();

    //             setIndents(data);
    //         } catch (error) {
    //             console.error('Error fetching pending indents:', error);
    //         }
    //     };

    //     fetchPendingIndents();
    // }, []);

    //   useEffect(() => {
    //     if (items.length > 0 && indents.length > 0) {
    //       const combined = indents.map((indent) => {
    //         const item = items.find(item => item.indent_no === indent.indent_no && item.Location_id === indent.location_id);


    //         return {
    //           ...indent,
    //           itemDesc: item ? item.itemDesc : 'N/A',
    //           itemUOM: item ? item.itemUOM : 'N/A',
    //           Approved_qty: item ? item.Approved_qty : "N/A",
    //           Supp_Nm: item ? item.Supp_Nm : 'N/A',
    //           Indent_dt: item ? item.Indent_dt : 'N/A',
    //           all_remarks: item ? item.all_remarks : 'N/A',
    //           Location_Desc: item ? item.Location_Desc : 'N/A',
    //           taxRate: item ? item.taxRate : 'N/A',
    //           hsnCode: item ? item.hsnCode : 'N/A',
    //           qty: item ? item.qty : 'N/A',
    //           Location_id: item ? item.Location_id : 'N/A',
    //         };
    //       }).filter((combinedItem) => combinedItem.Indent_dt !== 'N/A' && combinedItem.Location_id !== 'N/A');


    //       console.log("Combined Data after update:", combined);
    //       setCombinedData(combined);
    //     }
    //   }, [items, indents]);

    //   console.log('this is the combinedData',combinedData)





    // const [indents, setIndents] = useState([]);
    // const [items, setItems] = useState('');
    // const [allPI, setAllPI] = useState('')
    // const [combinedData, setCombinedData] = useState([]);
    // const [ALLData, setAllData] = useState([]);
    // // State for the date range
    // const [fromDate, setFromDate] = useState(null);
    // const [toDate, setToDate] = useState(null);

    // // Function to format date to YYYY-MM-DD
    // function formatDateToDateInput(date) {
    //     const dateObj = new Date(date);
    //     const year = dateObj.getFullYear();
    //     const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    //     const day = dateObj.getDate().toString().padStart(2, '0');
    //     return `${year}-${month}-${day}`;
    // }

    // // Fetch items data
    // useEffect(() => {
    //     axios.get('https://erpapi.emedha.in/pages/api/api/items-indents')
    //         .then((response) => {

    //             const filteredItems = response.data.filter(item => item.Flage === 1 && item.PO_rais !== 1);
    //             setItems(filteredItems);
    //             const filteredALLPI = response.data.filter(item => item.Flage === 1 );
    //             setAllPI(filteredALLPI)
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching items:', error);
    //         });
    // }, []);

    // // Fetch pending indents data
    // useEffect(() => {
    //     const fetchPendingIndents = async () => {
    //         try {
    //             const response = await fetch('https://erpapi.emedha.in/pages/api/api/pending-indents');
    //             const data = await response.json();
    //             setIndents(data);
    //         } catch (error) {
    //             console.error('Error fetching pending indents:', error);
    //         }
    //     };

    //     fetchPendingIndents();
    // }, []);

    // // Combine items and indents data
    // useEffect(() => {
    //     if (items.length > 0 && indents.length > 0) {
    //         const combined = indents.map((indent) => {
    //             const item = items.find(item => item.indent_no === indent.indent_no && item.Location_id === indent.location_id);
    //             return {
    //                 ...indent,
    //                 itemDesc: item ? item.itemDesc : 'N/A',
    //                 itemUOM: item ? item.itemUOM : 'N/A',
    //                 Approved_qty: item ? item.Approved_qty : "N/A",
    //                 Supp_Nm: item ? item.Supp_Nm : 'N/A',
    //                 Indent_dt: item ? formatDateToDateInput(item.Indent_dt) : 'N/A', 
    //                 all_remarks: item ? item.all_remarks : 'N/A',
    //                 Location_Desc: item ? item.Location_Desc : 'N/A',
    //                 taxRate: item ? item.taxRate : 'N/A',
    //                 hsnCode: item ? item.hsnCode : 'N/A',
    //                 qty: item ? item.qty : 'N/A',
    //                 Location_id: item ? item.Location_id : 'N/A',
    //             };
    //         }).filter((combinedItem) => combinedItem.Indent_dt !== 'N/A' && combinedItem.Location_id !== 'N/A');

    //         setCombinedData(combined);
    //     }
    // }, [items, indents]);


    // useEffect(() => {
    //     if (allPI.length > 0 && indents.length > 0) {
    //         const combineed = indents.map((indent) => {
    //             const item = allPI.find(item => item.indent_no === indent.indent_no && item.Location_id === indent.location_id);
    //             return {
    //                 ...indent,
    //                 itemDesc: item ? item.itemDesc : 'N/A',
    //                 itemUOM: item ? item.itemUOM : 'N/A',
    //                 Approved_qty: item ? item.Approved_qty : "N/A",
    //                 Supp_Nm: item ? item.Supp_Nm : 'N/A',
    //                 Indent_dt: item ? formatDateToDateInput(item.Indent_dt) : 'N/A', 
    //                 all_remarks: item ? item.all_remarks : 'N/A',
    //                 Location_Desc: item ? item.Location_Desc : 'N/A',
    //                 taxRate: item ? item.taxRate : 'N/A',
    //                 hsnCode: item ? item.hsnCode : 'N/A',
    //                 qty: item ? item.qty : 'N/A',
    //                 Location_id: item ? item.Location_id : 'N/A',
    //             };
    //         }).filter((combinedItem) => combinedItem.Indent_dt !== 'N/A' && combinedItem.Location_id !== 'N/A');

    //         setAllData(combineed);
    //     }
    // }, [allPI, indents]);


    // // Filter combinedData based on selected date range
    // const filterByDateRange = (data) => {
    //     if (!fromDate || !toDate) return [];

    //     return data.filter(item => {
    //         const indentDate = new Date(item.Indent_dt); // Parse the Indent_dt to Date object
    //         return indentDate >= fromDate && indentDate <= toDate;
    //     });
    // };

    // const filteredData = filterByDateRange(combinedData);

    // const [allPI, setAllPI] = useState([]);
    // const [items, setItems] = useState([]);
    // const [indents, setIndents] = useState([]);
    // const [combinedData, setCombinedData] = useState([]);
    // const [ALLData, setAllData] = useState([]);
    // const [selectedData, setSelectedData] = useState(null); // State for dropdown selection
    // const [fromDate, setFromDate] = useState(null);
    // const [toDate, setToDate] = useState(null);

    // // Function to format date to YYYY-MM-DD
    // const formatDateToDateInput = (date) => {
    //     const dateObj = new Date(date);
    //     const year = dateObj.getFullYear();
    //     const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    //     const day = dateObj.getDate().toString().padStart(2, '0');
    //     return `${year}-${month}-${day}`;
    // };

    // // Fetch items and PI data
    // useEffect(() => {
    //     axios.get('https://erpapi.emedha.in/pages/api/api/items-indents')
    //         .then((response) => {
    //             const filteredItems = response.data.filter(item => item.Flage === 1 && item.PO_rais !== 1);
    //             setItems(filteredItems);
    //             const filteredALLPI = response.data.filter(item => item.Flage === 1);
    //             setAllPI(filteredALLPI);
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching items:', error);
    //         });
    // }, []);

    // // Fetch pending indents data
    // useEffect(() => {
    //     const fetchPendingIndents = async () => {
    //         try {
    //             const response = await fetch('https://erpapi.emedha.in/pages/api/api/pending-indents');
    //             const data = await response.json();
    //             setIndents(data);
    //         } catch (error) {
    //             console.error('Error fetching pending indents:', error);
    //         }
    //     };
    //     fetchPendingIndents();
    // }, []);

    // // Combine items and indents data when ALLData is selected
    // useEffect(() => {
    //     if (selectedData === 'ALLData' && allPI.length > 0 && indents.length > 0) {
    //         const combined = indents.map((indent) => {
    //             const item = allPI.find(item => item.indent_no === indent.indent_no && item.Location_id === indent.location_id);
    //             return {
    //                 ...indent,
    //                 itemDesc: item ? item.itemDesc : 'N/A',
    //                 itemUOM: item ? item.itemUOM : 'N/A',
    //                 Approved_qty: item ? item.Approved_qty : 'N/A',
    //                 Supp_Nm: item ? item.Supp_Nm : 'N/A',
    //                 Indent_dt: item ? formatDateToDateInput(item.Indent_dt) : 'N/A',
    //                 all_remarks: item ? item.all_remarks : 'N/A',
    //                 Location_Desc: item ? item.Location_Desc : 'N/A',
    //                 taxRate: item ? item.taxRate : 'N/A',
    //                 hsnCode: item ? item.hsnCode : 'N/A',
    //                 qty: item ? item.qty : 'N/A',
    //                 Location_id: item ? item.Location_id : 'N/A',
    //             };
    //         }).filter((combinedItem) => combinedItem.Indent_dt !== 'N/A' && combinedItem.Location_id !== 'N/A');

    //         setAllData(combined);
    //     }
    // }, [selectedData, allPI, indents]);

    // // Combine items and indents data when PIData is selected
    // useEffect(() => {
    //     if (selectedData === 'PIData' && items.length > 0 && indents.length > 0) {
    //         const combined = indents.map((indent) => {
    //             const item = items.find(item => item.indent_no === indent.indent_no && item.Location_id === indent.location_id);
    //             return {
    //                 ...indent,
    //                 itemDesc: item ? item.itemDesc : 'N/A',
    //                 itemUOM: item ? item.itemUOM : 'N/A',
    //                 Approved_qty: item ? item.Approved_qty : 'N/A',
    //                 Supp_Nm: item ? item.Supp_Nm : 'N/A',
    //                 Indent_dt: item ? formatDateToDateInput(item.Indent_dt) : 'N/A',
    //                 all_remarks: item ? item.all_remarks : 'N/A',
    //                 Location_Desc: item ? item.Location_Desc : 'N/A',
    //                 taxRate: item ? item.taxRate : 'N/A',
    //                 hsnCode: item ? item.hsnCode : 'N/A',
    //                 qty: item ? item.qty : 'N/A',
    //                 Location_id: item ? item.Location_id : 'N/A',
    //             };
    //         }).filter((combinedItem) => combinedItem.Indent_dt !== 'N/A' && combinedItem.Location_id !== 'N/A');

    //         setCombinedData(combined);
    //     }
    // }, [selectedData, items, indents]);

    // // Filter combinedData based on selected date range
    // // const filterByDateRange = (data) => {

    // //     if (!fromDate || !toDate) return [];
    // //     const fromDateObj = new Date(fromDate);
    // //     const toDateObj = new Date(toDate);
    // //     return data.filter(item => {
    // //         const indentDate = new Date(item.Indent_dt); // Parse the Indent_dt to Date object
    // //         // return indentDate >= fromDate && indentDate <= toDate;
    // //         return indentDate >= fromDateObj && indentDate <= toDateObj;
    // //     });
    // // };
    // const filterByDateRange = (data) => {
    //     if (!fromDate || !toDate) return [];

    //     // Set the time of the dates to midnight (00:00:00)
    //     const fromDateObj = new Date(fromDate);
    //     fromDateObj.setHours(0, 0, 0, 0); // Set the time to 00:00:00

    //     const toDateObj = new Date(toDate);
    //     toDateObj.setHours(23, 59, 59, 999); // Set the time to 23:59:59 to include the entire day

    //     return data.filter(item => {
    //         // Parse the Indent_dt from the data (assumed to be in YYYY-MM-DD format)
    //         const indentDate = new Date(item.Indent_dt);

    //         // Compare the dates, ensuring we include the entire day for toDate
    //         return indentDate >= fromDateObj && indentDate <= toDateObj;
    //     });
    // };


    // const filteredCombinedData = filterByDateRange(combinedData);
    // const filteredALLData = filterByDateRange(ALLData);

    // // Dropdown options for React-Select
    // const dropdownOptions = [
    //     { value: 'ALLData', label: 'ALL Data' },
    //     { value: 'PIData', label: 'PI Data' },
    // ];
    // // Reset data when the selection changes
    // const handleDropdownChange = (selected) => {
    //     setSelectedData(selected.value);

    //     // Reset the data
    //     setAllData([]); // Reset ALLData
    //     setCombinedData([]); // Reset combinedData

    //     // Optionally, reset date pickers or other states
    //     setFromDate(null);
    //     setToDate(null);
    // };


    // // Define styles for PDF
    // const styles = StyleSheet.create({
    //     page: {
    //         padding: 20,
    //         fontSize: 10,
    //     },
    //     tableHeader: {
    //         flexDirection: 'row',
    //         borderBottom: '1px solid black',
    //         marginBottom: 5,
    //     },
    //     tableRow: {
    //         flexDirection: 'row',
    //     },
    //     tableCell: {
    //         width: '10%',
    //         textAlign: 'center',
    //         padding: 5,
    //     },
    // });

    // const [exportFormat, setExportFormat] = useState('pdf'); // Default is 'pdf'

    // const handleExportFormatChange = (selectedOption) => {
    //     setExportFormat(selectedOption.value);
    // };


    // const handleExportToPDF = () => {
    //     const data = selectedData === 'ALLData' ? filteredALLData : filteredCombinedData;

    //     const MyDocument = () => (
    //         <Document>
    //             <Page style={styles.page}>
    //                 <View style={styles.tableHeader}>
    //                     <Text style={styles.tableCell}>Location</Text>
    //                     <Text style={styles.tableCell}>Indent No</Text>
    //                     <Text style={styles.tableCell}>Indent Dt</Text>
    //                     <Text style={styles.tableCell}>Item</Text>
    //                     <Text style={styles.tableCell}>Item desc</Text>
    //                     <Text style={styles.tableCell}>QTY</Text>
    //                     <Text style={styles.tableCell}>UOM</Text>
    //                     <Text style={styles.tableCell}>Approved Qty</Text>
    //                     <Text style={styles.tableCell}>Supplier</Text>
    //                     <Text style={styles.tableCell}>Remarks</Text>
    //                 </View>
    //                 {data.map((item, index) => (
    //                     <View style={styles.tableRow} key={index}>
    //                         <Text style={styles.tableCell}>{item.Location_Desc}</Text>
    //                         <Text style={styles.tableCell}>{item.indent_no}</Text>
    //                         <Text style={styles.tableCell}>{item.Indent_dt}</Text>
    //                         <Text style={styles.tableCell}>{item.itemCd}</Text>
    //                         <Text style={styles.tableCell}>{item.itemDesc}</Text>
    //                         <Text style={styles.tableCell}>{item.qty}</Text>
    //                         <Text style={styles.tableCell}>{item.itemUOM}</Text>
    //                         <Text style={styles.tableCell}>{item.Approved_qty}</Text>
    //                         <Text style={styles.tableCell}>{item.Supp_Nm}</Text>
    //                         <Text style={styles.tableCell}>{item.all_remarks}</Text>
    //                     </View>
    //                 ))}
    //             </Page>
    //         </Document>
    //     );

    //     ReactPDF.render(<MyDocument />, `${__dirname}/table.pdf`);
    // };




    // const handleExportToExcel = () => {
    //     const data = selectedData === 'ALLData' ? filteredALLData : filteredCombinedData;

    //     // Define the headers
    //     const wsData = [
    //         [
    //             'Location', 'Indent No', 'Indent Dt', 'Item', 'Item desc', 'QTY', 'UOM', 'Approved Qty', 'Supplier', 'Remarks'
    //         ],
    //         ...data.map(item => [
    //             item.Location_Desc,
    //             item.indent_no,
    //             item.Indent_dt,
    //             item.itemCd,
    //             item.itemDesc,
    //             item.qty,
    //             item.itemUOM,
    //             item.Approved_qty,
    //             item.Supp_Nm,
    //             item.all_remarks
    //         ])
    //     ];

    //     // Create a worksheet from the data
    //     const ws = XLSX.utils.aoa_to_sheet(wsData);

    //     // Create a new workbook and append the worksheet
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, 'Data');

    //     // Write the Excel file
    //     XLSX.writeFile(wb, 'table.xlsx');
    // };

    // const handlePrint = () => {
    //     if (exportFormat === 'pdf') {
    //         handleExportToPDF(); // Call the PDF export function
    //     } else if (exportFormat === 'excel') {
    //         handleExportToExcel(); // Call the Excel export function
    //     }
    // };

    // console.log(allPI)

    // console.log('this is all data', ALLData)


    const [allPI, setAllPI] = useState([]);
    const [items, setItems] = useState([]);
    const [indents, setIndents] = useState([]);
    const [combinedData, setCombinedData] = useState([]);
    const [ALLData, setAllData] = useState([]);
    const [selectedData, setSelectedData] = useState(null); // State for dropdown selection
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    // Function to format date to YYYY-MM-DD
    const formatDateToDateInput = (date) => {
        const dateObj = new Date(date);
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Fetch items and PI data
    useEffect(() => {
        axios.get('https://erpapi.emedha.in/pages/api/api/items-indents')
            .then((response) => {
                const filteredItems = response.data.filter(item => item.Flage === 1 && item.PO_rais !== 1);
                setItems(filteredItems);
                const filteredALLPI = response.data.filter(item => item.Flage === 1);
                setAllPI(filteredALLPI);
            })
            .catch((error) => {
                console.error('Error fetching items:', error);
            });
    }, []);

    // Fetch pending indents data
    useEffect(() => {
        const fetchPendingIndents = async () => {
            try {
                const response = await fetch('https://erpapi.emedha.in/pages/api/api/pending-indents');
                const data = await response.json();
                setIndents(data);
            } catch (error) {
                console.error('Error fetching pending indents:', error);
            }
        };
        fetchPendingIndents();
    }, []);

    // Combine items and indents data when ALLData or PIData is selected
    useEffect(() => {
        const fetchCombinedData = () => {
            const data = selectedData === 'ALLData' ? allPI : items;
            const combined = indents.map((indent) => {
                const item = data.find(item => item.indent_no === indent.indent_no && item.Location_id === indent.location_id);
                return {
                    ...indent,
                    itemDesc: item ? item.itemDesc : 'N/A',
                    itemUOM: item ? item.itemUOM : 'N/A',
                    Approved_qty: item ? item.Approved_qty : 'N/A',
                    Supp_Nm: item ? item.Supp_Nm : 'N/A',
                    Indent_dt: item ? formatDateToDateInput(item.Indent_dt) : 'N/A',
                    all_remarks: item ? item.all_remarks : 'N/A',
                    Location_Desc: item ? item.Location_Desc : 'N/A',
                    taxRate: item ? item.taxRate : 'N/A',
                    hsnCode: item ? item.hsnCode : 'N/A',
                    qty: item ? item.qty : 'N/A',
                    Location_id: item ? item.Location_id : 'N/A',
                };
            }).filter((combinedItem) => combinedItem.Indent_dt !== 'N/A' && combinedItem.Location_id !== 'N/A');

            selectedData === 'ALLData' ? setAllData(combined) : setCombinedData(combined);
        };

        if (selectedData && indents.length > 0) {
            fetchCombinedData();
        }
    }, [selectedData, allPI, items, indents]);

    // Filter combinedData based on selected date range
    const filterByDateRange = (data) => {
        if (!fromDate || !toDate) return [];
        const fromDateObj = new Date(fromDate);
        const toDateObj = new Date(toDate);
        fromDateObj.setHours(0, 0, 0, 0);
        toDateObj.setHours(23, 59, 59, 999);
        return data.filter(item => {
            const indentDate = new Date(item.Indent_dt);
            return indentDate >= fromDateObj && indentDate <= toDateObj;
        });
    };

    const filteredCombinedData = filterByDateRange(combinedData);
    const filteredALLData = filterByDateRange(ALLData);

    // Dropdown options for React-Select
    const dropdownOptions = [
        { value: 'ALLData', label: 'ALL Data' },
        { value: 'PIData', label: 'PI Data' },
    ];

    // Reset data when the selection changes
    const handleDropdownChange = (selected) => {
        setSelectedData(selected.value);
        setAllData([]); // Reset ALLData
        setCombinedData([]); // Reset combinedData
        setFromDate(null);
        setToDate(null);
    };

    // PDF Export Styles
    const styles = StyleSheet.create({
        page: {
            padding: 30,
            fontSize: 7,
            border: '1px solid black', // Adding a border around the page
        },
        tableHeader: {
            flexDirection: 'row',
            borderBottom: '1px solid black',
            marginBottom: 5,
        },
        tableRow: {
            flexDirection: 'row',
        },
        // tableCell: {
        //   width: '10%',
        //   textAlign: 'center',
        //   padding: 5,
        // },
        tableCellh: {
            flex: 1,
            borderWidth: 1,

            fontWeight: 'bold',
            color: 'blue',
            padding: 5,
            textAlign: 'center',
        },
        tableCell: {
            flex: 1,
            borderWidth: 1,

            padding: 5,
            textAlign: 'center',
        },
        dateRangeText1: {
            width: '50%',
            fontSize: 12,
            textAlign: 'left',
            fontWeight: 'bold',
        },
        dateRangeText2: {
            width: '50%',
            marginBottom: 10,
            textAlign: 'right',
            fontSize: 12,
            fontWeight: 'bold',
        },

        companyInfoContainer: {
            flexDirection: 'row', // Stack the company name and GST vertically
            alignItems: 'flex-start', // Align text to the left
            marginBottom: 20, // Add space below the company information

        },
        companyName: {
            fontSize: '18px', // Adjust font size as needed
            fontWeight: 'bold', // Make the company name bold
            color: 'blue',
            width: '50%',
            fontSize: 12,
            textAlign: 'left',
            fontWeight: 'bold',
        },
        gstNumber: {
            fontSize: '14px', // Slightly smaller font for the GST number
            color: 'blue',
            width: '100%',
            marginBottom: 10,
            textAlign: 'right',
            fontSize: 12,
            fontWeight: 'bold',
        },
        image: {
            width: 'auto', // Set the width of the image
            height: 35, // Set the height of the image
            marginBottom: 20,
        },
    });


    const [exportFormat, setExportFormat] = useState('pdf'); // Default is 'pdf'
    const [pdfLinkVisible, setPdfLinkVisible] = useState(false);

    const handleExportFormatChange = (selectedOption) => {
        setExportFormat(selectedOption.value);
    };

    const [companyData, setCompanyData] = useState([]); // State to store fetched company data

    const [companyDataName, setCompanyDataName] = useState([]);
    const [companyDataGST, setCompanyDataGST] = useState([]);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);


    useEffect(() => {
        const fetchCompanyData = async () => {
            try {
                const response = await axios.get('https://erpapi.emedha.in/pages/api/api/get-Company-data');
                setCompanyDataName(response.data[0].name);  // Set company data to state
                setCompanyDataGST(response.data[0].company_logo);
                setLoading(false);
            } catch (err) {
                setError('Error fetching company data');
                setLoading(false);
            }
        };

        fetchCompanyData();
    }, []);
    console.log(companyDataName)
    console.log(companyDataGST)

    const MyDocument = ({ data, companyDataName, companyDataGST }) => (
        <Document>
            <Page style={styles.page}>

                <View style={styles.companyInfoContainer}>
                    <Image style={styles.image} src={companyDataGST} />
                    <Text style={styles.gstNumber}>{companyDataName}</Text>
                </View>

                <Text style={{ textAlign: 'center', fontSize: '20px', color: 'blue', marginBottom: '20px' }}>PurchaseIndent VS PurchaseOrder</Text>
                <View style={{ flexDirection: 'row', marginBottom: 10 }}>
                    <Text style={styles.dateRangeText1}>From Date: {fromDate ? fromDate.toLocaleDateString() : 'N/A'}</Text>
                    <Text style={styles.dateRangeText2}>To Date: {toDate ? toDate.toLocaleDateString() : 'N/A'}</Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={styles.tableCellh}>Location</Text>
                    <Text style={styles.tableCellh}>Indent No</Text>
                    <Text style={styles.tableCellh}>Indent Dt</Text>
                    <Text style={styles.tableCellh}>Item code</Text>
                    <Text style={styles.tableCellh}>Item desc</Text>
                    <Text style={styles.tableCellh}>QTY</Text>
                    <Text style={styles.tableCellh}>UOM</Text>
                    <Text style={styles.tableCellh}>Approved Qty</Text>
                    <Text style={styles.tableCellh}>Supplier</Text>
                    <Text style={styles.tableCellh}>Remarks</Text>
                </View>
                {data.map((item, index) => (
                    <View style={styles.tableRow} key={index}>
                        <Text style={styles.tableCell}>{item.Location_Desc}</Text>
                        <Text style={styles.tableCell}>{item.indent_no}</Text>
                        <Text style={styles.tableCell}>{item.Indent_dt}</Text>
                        <Text style={styles.tableCell}>{item.itemCd}</Text>
                        <Text style={styles.tableCell}>{item.itemDesc}</Text>
                        <Text style={styles.tableCell}>{item.qty}</Text>
                        <Text style={styles.tableCell}>{item.itemUOM}</Text>
                        <Text style={styles.tableCell}>{item.Approved_qty}</Text>
                        <Text style={styles.tableCell}>{item.Supp_Nm}</Text>
                        <Text style={styles.tableCell}>{item.all_remarks}</Text>
                    </View>
                ))}
            </Page>
        </Document>
    );

    // const handlePrint = () => {
    //     const data = selectedData === 'ALLData' ? filteredALLData : filteredCombinedData;
    //     if (exportFormat === 'pdf') {
    //         setPdfLinkVisible(true); // Show the PDF download link when "Export" is clicked
    //     } else if (exportFormat === 'excel') {
    //         handleExportToExcel();
    //     }
    // };
    const handlePrint = () => {
        const data = selectedData === 'ALLData' ? filteredALLData : filteredCombinedData;

        if (exportFormat === 'pdf') {
            // Directly trigger the PDF download
            const doc = <MyDocument data={data} companyDataName={companyDataName} companyDataGST={companyDataGST} />;
            pdf(doc).toBlob().then((blob) => {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'table.pdf'; // Set the file name for the downloaded PDF
                link.click(); // Trigger the download
            });
        } else if (exportFormat === 'excel') {
            handleExportToExcel(); // Call the Excel export function
        }
    };



    // Handle Export Format Change (PDF/Excel)


    // Export to PDF
    // const handleExportToPDF = () => {
    //     const data = selectedData === 'ALLData' ? filteredALLData : filteredCombinedData;

    //     const MyDocument = () => (
    //         <Document>
    //             <Page style={styles.page}>
    //                 <View style={styles.tableHeader}>
    //                     <Text style={styles.tableCell}>Location</Text>
    //                     <Text style={styles.tableCell}>Indent No</Text>
    //                     <Text style={styles.tableCell}>Indent Dt</Text>
    //                     <Text style={styles.tableCell}>Item</Text>
    //                     <Text style={styles.tableCell}>Item desc</Text>
    //                     <Text style={styles.tableCell}>QTY</Text>
    //                     <Text style={styles.tableCell}>UOM</Text>
    //                     <Text style={styles.tableCell}>Approved Qty</Text>
    //                     <Text style={styles.tableCell}>Supplier</Text>
    //                     <Text style={styles.tableCell}>Remarks</Text>
    //                 </View>
    //                 {data.map((item, index) => (
    //                     <View style={styles.tableRow} key={index}>
    //                         <Text style={styles.tableCell}>{item.Location_Desc}</Text>
    //                         <Text style={styles.tableCell}>{item.indent_no}</Text>
    //                         <Text style={styles.tableCell}>{item.Indent_dt}</Text>
    //                         <Text style={styles.tableCell}>{item.itemCd}</Text>
    //                         <Text style={styles.tableCell}>{item.itemDesc}</Text>
    //                         <Text style={styles.tableCell}>{item.qty}</Text>
    //                         <Text style={styles.tableCell}>{item.itemUOM}</Text>
    //                         <Text style={styles.tableCell}>{item.Approved_qty}</Text>
    //                         <Text style={styles.tableCell}>{item.Supp_Nm}</Text>
    //                         <Text style={styles.tableCell}>{item.all_remarks}</Text>
    //                     </View>
    //                 ))}
    //             </Page>
    //         </Document>
    //     );

    //     // ReactPDF.render(<MyDocument />, `${__dirname}/table.pdf`);
    // };

    // Export to Excel


    const handleExportToExcel = () => {
        const data = selectedData === 'ALLData' ? filteredALLData : filteredCombinedData;

        const wsData = [
            ['Location', 'Indent No', 'Indent Dt', 'Item', 'Item desc', 'QTY', 'UOM', 'Approved Qty', 'Supplier', 'Remarks'],
            ...data.map(item => [
                item.Location_Desc,
                item.indent_no,
                item.Indent_dt,
                item.itemCd,
                item.itemDesc,
                item.qty,
                item.itemUOM,
                item.Approved_qty,
                item.Supp_Nm,
                item.all_remarks,
            ]),
        ];

        const ws = XLSX.utils.aoa_to_sheet(wsData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Data');
        XLSX.writeFile(wb, 'table.xlsx');
    };

    // Handle Print (export)
    // const handlePrint = () => {
    //     if (exportFormat === 'pdf') {
    //         handleExportToPDF();
    //     } else if (exportFormat === 'excel') {
    //         handleExportToExcel();
    //     }
    // };


    return (

        <div style={{ margin: '0 auto', backgroundColor: '#ffffff', padding: '1rem', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', border: '1px solid black', borderRadius: '10px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <img src={A1} alt="item" style={{ width: "20%" }} />
                <h1 style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>PurchaseIndent VS PurchaseOrder</h1>
                <div style={{ display: "flex", gap: "1rem", cursor: 'pointer' }}>
                    {/* <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.add && userPermissions.add !== 0 ? "pointer" : "not-allowed",
                        opacity: userPermissions.add && userPermissions.add !== 0 && getButtonState('create') ? 1 : 0.5
                    }}>
                        <FaPlus size={30} onClick={() => {
                            if (userPermissions.add && userPermissions.add !== 0) {
                                toggleModal();
                                setShowEditFormm(false);
                                setShowCreateForm(true);
                                // setShowViewForm(false);
                                setFormMode('create');
                            }
                        }} />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.edit && userPermissions.edit !== 0 ? "pointer" : "not-allowed",
                        opacity: userPermissions.edit && userPermissions.edit !== 0 && getButtonState('edit') ? 1 : 0.5
                    }}>
                        <MdEdit size={30} onClick={() => {
                            if (userPermissions.edit && userPermissions.edit !== 0) {
                                setShowEditFormm(true);
                                setShowCreateForm(false);
                                // setShowViewForm(false);
                                setFormMode('edit');
                            } else {
                                alert("You do not have permission to edit.");
                            }
                        }} />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.view && userPermissions.view !== 0 ? "pointer" : "not-allowed",
                        opacity: userPermissions.view && userPermissions.view !== 0 && getButtonState('view') ? 1 : 0.5
                    }}>
                        <LuView size={30} onClick={() => {
                            if (userPermissions.view && userPermissions.view !== 0) {
                                setShowEditFormm(true);
                                setShowCreateForm(false);
                                // setShowViewForm(true);
                                setFormMode('view');
                            } else {
                                alert("You do not have permission to view.");
                            }
                        }} />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear') ? "pointer" : "not-allowed",
                        opacity: userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear') ? 1 : 0.5
                    }}>
                        <HiOutlineRefresh size={30} onClick={userPermissions.clear && userPermissions.clear !== 0 ? handleRefresh : null} />
                    </div>

                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.save && userPermissions.save !== 0 && getButtonState('save') ? "pointer" : "not-allowed",
                        opacity: userPermissions.save && userPermissions.save !== 0 && getButtonState('save') ? 1 : 0.5
                    }}>
                        <FaSave size={30} o onClick={() => {
                            //userPermissions.save && userPermissions.save !== 0 ? handleSave : null} />
                            if (userPermissions.save && userPermissions.save !== 0) {
                                if (formMode === 'create') {
                                    handleSave(); // If formMode is approve, use handleApprove
                                } else if (formMode === 'edit') {
                                    handleSubmit(); // If formMode is create or edit, use handleSave
                                }
                            } else {
                                alert("You do not have permission to save.");
                            }
                        }}
                        />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve') ? "pointer" : "not-allowed",
                        opacity: userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve') ? 1 : 0.5
                    }}>
                        <FaCheck size={30} onClick={userPermissions.approve && userPermissions.approve !== 0 ? handleApprove : null} />
                    </div> */}
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        // cursor: userPermissions.print && userPermissions.print !== 0 && getButtonState('print') ? "pointer" : "not-allowed",
                        // opacity: userPermissions.print && userPermissions.print !== 0 && getButtonState('print') ? 1 : 0.5
                    }} title='Print'>
                        <IoPrint size={30} onClick={handlePrint} />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        // cursor: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? "pointer" : "not-allowed",
                        // opacity: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? 1 : 0.5
                    }} title='Exit'>
                        <RiCloseLargeFill size={30}
                            onClick={handleBack}
                        //  onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null}
                        />
                    </div>
                </div>
            </div>
            <hr />

            <>
                <Container>
                    <Row className="mt-4">
                        {/* Dropdown for selecting data */}
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Select Data Type</Form.Label>
                                <Select
                                    options={dropdownOptions}
                                    onChange={handleDropdownChange}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: 'transparent',
                                            borderColor: '#ccc', // Optional: change border color if needed
                                        }),
                                        // menu: (provided) => ({
                                        //     ...provided,
                                        //     backgroundColor: 'transparent', // You can also change the dropdown menu background
                                        // }),
                                    }}
                                    placeholder="Select data type"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Date Pickers */}
                    <Row className="mt-4">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>From Date</Form.Label>
                                <DatePicker
                                    selected={fromDate}
                                    onChange={setFromDate}
                                    placeholderText="From Date"
                                    dateFormat="MM/dd/yyyy"
                                    className="form-control custom-datepicker"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>To Date</Form.Label>
                                <DatePicker
                                    selected={toDate}
                                    onChange={setToDate}
                                    placeholderText="To Date"
                                    dateFormat="MM/dd/yyyy"
                                    className="form-control custom-datepicker"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group>

                                <Select
                                    options={[
                                        { label: 'PDF', value: 'pdf' },
                                        { label: 'Excel', value: 'excel' }
                                    ]}
                                    onChange={handleExportFormatChange}
                                    defaultValue={{ label: 'PDF', value: 'pdf' }}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: 'transparent',
                                            borderColor: '#ccc', // Optional: change border color if needed
                                        }),
                                        // menu: (provided) => ({
                                        //     ...provided,
                                        //     backgroundColor: 'transparent', // You can also change the dropdown menu background
                                        // }),
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Display filtered data */}
                    <Row className="mt-4">
                        <Col>
                            {selectedData === 'ALLData' && (
                                <div>
                                    <h3>Filtered ALL Data</h3>
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Location</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Indent No</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Indent Dt</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Item code</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Item desc</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>QTY</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>UOM</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Approved Qty</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Supplier</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Remarks</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredALLData.map((item, index) => (
                                                    <tr key={index}>

                                                        <td className="text-center " style={{ minWidth: '90px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.Location_Desc}</td>
                                                        <td className="text-center " style={{ minWidth: '90px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.indent_no}</td>
                                                        <td className="text-center " style={{ minWidth: '90px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.Indent_dt}</td>
                                                        <td className="text-center " style={{ minWidth: '90px', border: '1px solid black', backgroundColor: '#ffffff' }}> {item.itemCd}</td>
                                                        <td className="text-center " style={{ minWidth: '90px', border: '1px solid black', backgroundColor: '#ffffff' }}> {item.itemDesc}</td>
                                                        <td className="text-center " style={{ minWidth: '90px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.qty}</td>
                                                        <td className="text-center " style={{ minWidth: '90px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.itemUOM}</td>
                                                        <td className="text-center " style={{ minWidth: '90px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.Approved_qty}</td>
                                                        <td className="text-center " style={{ minWidth: '90px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.Supp_Nm}</td>

                                                        <td className="text-center " style={{ minWidth: '90px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.all_remarks}</td>



                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                            )}

                            {selectedData === 'PIData' && (
                                <div>
                                    <h3>Filtered PI Data</h3>
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Location</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Indent No</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Indent Dt</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Item</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Item desc</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>QTY</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>UOM</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Approved Qty</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Supplier</th>
                                                <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Remarks</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredCombinedData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center " style={{ minWidth: '100px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.Location_Desc}</td>
                                                        <td className="text-center " style={{ minWidth: '100px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.indent_no}</td>
                                                        <td className="text-center " style={{ minWidth: '100px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.Indent_dt}</td>
                                                        <td className="text-center " style={{ minWidth: '100px', border: '1px solid black', backgroundColor: '#ffffff' }}> {item.itemCd}</td>
                                                        <td className="text-center " style={{ minWidth: '100px', border: '1px solid black', backgroundColor: '#ffffff' }}> {item.itemDesc}</td>
                                                        <td className="text-center " style={{ minWidth: '100px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.qty}</td>
                                                        <td className="text-center " style={{ minWidth: '100px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.itemUOM}</td>
                                                        <td className="text-center " style={{ minWidth: '100px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.Approved_qty}</td>
                                                        <td className="text-center " style={{ minWidth: '100px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.Supp_Nm}</td>

                                                        <td className="text-center " style={{ minWidth: '100px', border: '1px solid black', backgroundColor: '#ffffff' }}>{item.all_remarks}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <Row>

                        {/* <Col md={6}>
                            <Form.Group>
                                <Form.Label>Select Export Format</Form.Label>
                                <Select
                                    options={[
                                        { label: 'PDF', value: 'pdf' },
                                        { label: 'Excel', value: 'excel' }
                                    ]}
                                    onChange={handleExportFormatChange}
                                    defaultValue={{ label: 'PDF', value: 'pdf' }}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: 'transparent',
                                            borderColor: '#ccc', // Optional: change border color if needed
                                        }),
                                        // menu: (provided) => ({
                                        //     ...provided,
                                        //     backgroundColor: 'transparent', // You can also change the dropdown menu background
                                        // }),
                                    }}
                                />
                            </Form.Group>
                        </Col> */}
                    </Row>
                    <Row className="mt-4">
                        {/* <Col md={12}>
                            <Button onClick={handlePrint}>Export</Button>
                        </Col> */}
                    </Row>
                    {/* {pdfLinkVisible && exportFormat === 'pdf' && (
                        <PDFDownloadLink document={<MyDocument data={selectedData === 'ALLData' ? filteredALLData : filteredCombinedData} />} fileName="table.pdf">
                            {({ loading }) => (loading ? 'Loading document...' : 'Download PDF')}
                        </PDFDownloadLink>
                    )} */}

                </Container>
            </>






            {showCreateForm && (

                <>

                </>
            )}

            <>
                {showEditformm && (
                    <>

                    </>
                )}

            </>



        </div>
    );
};

export default PIvs;

